module.exports = __webpack_public_path__ + "assets/img/profile-avatar.svg";